import { useEffect, useState } from 'react';

import { TOKENS } from './tokens';

export type NavAppearance = 'hero' | 'scrolled' | 'dark';

const HERO_SCROLL_THRESHOLD = 60;

export const useNavAppearance = (): NavAppearance => {
  const [overTestimonials, setOverTestimonials] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const testimonialsEl = document.getElementById('testimonials');
    if (!testimonialsEl) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => setOverTestimonials(entry.isIntersecting),
      {
        rootMargin: `-${TOKENS.headerOffset} 0px 0px 0px`,
        threshold: 0,
      },
    );

    observer.observe(testimonialsEl);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let frame = 0;

    const updateScroll = () => {
      setScrollY(window.scrollY);
    };

    const onScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateScroll);
    };

    updateScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  if (overTestimonials) {
    return 'dark';
  }

  if (scrollY < HERO_SCROLL_THRESHOLD) {
    return 'hero';
  }

  return 'scrolled';
};
